import { useMemo } from "react"
import { PendingSubscriptionEventType } from "../../../../../types"
import {
  TrendingUp,
  Pencil,
  FileText,
  Check,
  AlertCircle,
  X
} from "lucide-react"

function getEventIcon(eventType: string) {
  switch (eventType) {
    case "pending_subscription.created":
      return FileText
    case "pending_subscription.updated":
      return Pencil
    case "pending_subscription.cancelled":
      return X
    case "pending_subscription.priced":
      return TrendingUp
    case "pending_subscription.close_to_converting":
      return AlertCircle
    case "pending_subscription.converted":
      return Check
    case "pending_subscription.error":
      return AlertCircle
    default:
      return FileText
  }
}

interface Props {
  event_type: PendingSubscriptionEventType
  connectorVisible: boolean
}

const ActivityIcon = ({ event_type, connectorVisible }: Props) => {
  const Icon = useMemo(() => getEventIcon(event_type), [event_type])

  return (
    <div className="rounded-full bg-neutral-500 p-3 relative">
      {connectorVisible && (
        <div className="absolute top-12 left-6 mt-1 -ml-[1px] w-0 h-4 border-2 border-neutral-400"></div>
      )}
      <Icon className="text-white" />
    </div>
  )
}

export default ActivityIcon
